import React from "react";
import { FaqList } from "../FaqList";
import { Reveal } from "../Reveal";
import { SectionIntro } from "../SectionIntro";
export function FaqSection() {
  return <section id="faq" className="scroll-mt-20 bg-stone px-5 py-24 text-ink sm:px-8 sm:py-32 lg:px-12 lg:py-36" aria-labelledby="faq-title" data-id="element-119" data-mp="2ixvrozvbwzbd">
      <div className="mx-auto grid max-w-[1500px] gap-16 lg:grid-cols-[0.7fr_1.3fr] lg:gap-24" data-id="element-120" data-mp="2a2xzjv009ql3">
        <Reveal data-id="element-121" data-mp="1v673nvpjix08"><SectionIntro eyebrow="FAQ" title={<span id="faq-title" data-id="element-123" data-mp="1v8kzi6s1od8u">What to know.</span>} body="Clear answers about the paid assessment and what happens next." data-id="element-122" data-mp="1v5f8glzuv1ah" /></Reveal>
        <Reveal delay={0.08} data-id="element-124" data-mp="1m61x1ns682n4"><FaqList data-id="element-125" data-mp="1m6k4zho745av" /></Reveal>
      </div>
    </section>;
}